// https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/btoa

// convert a Unicode string to a string in which
// each 16-bit unit occupies only one byte
function toBinary(s: string): string {
    const codeUnits = new Uint16Array(s.length);
    for (let i = 0; i < codeUnits.length; i++) {
        codeUnits[i] = s.charCodeAt(i);
    }
    return String.fromCharCode(...new Uint8Array(codeUnits.buffer));
}

function fromBinary(binary: string): string {
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < bytes.length; i++) {
        bytes[i] = binary.charCodeAt(i);
    }
    return String.fromCharCode(...new Uint16Array(bytes.buffer));
}

let b64Encoder: (s: string) => string;
try {
    b64Encoder = btoa;
} catch {
    // We have to support both browsers and Node in the same file.
    // Browsers have btoa; Node has Buffer methods.
    // "binary" is presumed to be the internal string encoding used
    // by btoa in browsers.
    b64Encoder = s => Buffer.from(s, "binary").toString("base64");
}

export const base64Encode = b64Encoder;

export function base64EncodeString(s: string): string {
    return b64Encoder(toBinary(s));
}

let b64Decoder: (s: string) => string;
try {
    b64Decoder = atob;
} catch {
    // We have to support both browsers and Node in the same file.
    // Browsers have atob; Node has Buffer methods.
    // "binary" is presumed to be the internal string encoding used
    // by atob in browsers.
    b64Decoder = s => Buffer.from(s, "base64").toString("binary");
}

export const base64Decode = b64Decoder;

export function base64DecodeString(s: string): string {
    return fromBinary(b64Decoder(s));
}
